// extracted by mini-css-extract-plugin
module.exports = {"wrap_div":"SquadManager_wrap_div__1_7TE","squad_table":"SquadManager_squad_table__1yF7M","team_modal":"SquadManager_team_modal__2JSLV"};